<template>
    <div>
        <div class="content-header">
            <PageTitleComponent title="Configuración de sesión"/>
        </div>
        
        <section class="content">
            <div class="container-fluid">
                <template v-if="evento">
                    <template v-if="!evento.tiene_recinto">
                        <SesionSinRecinto :sesion_id="sesion_id" :evento_id="evento_id"/>
                    </template>
                    <template v-else>
                        <SesionConRecinto :sesion_id="sesion_id" :evento_id="evento_id" :evento="evento"/>
                    </template>
                </template>
                <template v-else>
                    <div class="card">
                        <LoaderComponent/>
                    </div>   
                </template>                             
            </div>
        </section>
        
    </div>
</template>

<script>
    import PageTitleComponent from '@/components/backend/components/PageTitleComponent';
    import LoaderComponent from '@/components/preloader/LoaderComponent';
    import SesionSinRecinto from './sinrecinto/SesionSinRecinto';
    import SesionConRecinto from './conrecinto/SesionesConRecinto';

    export default {
        props: ['evento_id', 'sesion_id'],
        data() {
            return {
                evento: null,
                loading: true,
            }
        },
        created() {
            this.getEvento();
        },
        methods: {
            getEvento : function() {
                this.loading = true;

                const params = {
                    filters : {},
                    evento_id: this.evento_id
                }

                this.$store.dispatch(this.config.getVuexAlias('back.events.show'), params).then(res => {
                    this.evento = res.data.data;
                }).finally(() => this.loading = false);
            }
        },
        components: {
            PageTitleComponent, LoaderComponent, SesionSinRecinto, SesionConRecinto
        }
    }
</script>
